import Swiper from "swiper/bundle";

//トップページ　キービジュアルスライダー
export function idxFunc() {
  const swiper = new Swiper('.swiper', {
    speed: 1000,
    loop: false,
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 10,  
    breakpoints: {
      768: {
        spaceBetween: 20,  
      }
    }
  });

  $(function() {
    $('.tab').on('click', function() {
      $('.tab__inner').fadeOut();
      $('.tab, .tab__inner').removeClass('active');
   
      $(this).addClass('active');
      
      var index = $('.tab').index(this);
      $('.tab__inner').eq(index).fadeIn();
      $('.tab__inner').eq(index).addClass('active');
    });
  });
}
